import { ROLE_RPM_ENROLLER } from '../constants/other';

export const isRpmEnrollerRole = (roles) =>
    !!(roles && roles.indexOf(ROLE_RPM_ENROLLER) !== -1);

/** Enroller on a clinical center (not C&E, RPM, GAPS, or Support). */
export const isRpmEnrollerClinicalCenter = (activeUser, roles) => {
    if (!isRpmEnrollerRole(roles) || !activeUser || !activeUser.center) {
        return false;
    }
    const center = activeUser.center;
    return !center.ce_flag
        && !center.rpm_flag
        && !center.gaps_flag
        && !center.support_flag;
};

/** Chart UX aligned with restricted clinical / RPM center tabs (not full clinical). */
export const isRpmEnrollerChartExperience = (activeUser, roles) =>
    isRpmEnrollerClinicalCenter(activeUser, roles);

/** Clinical center (not C&E, RPM, GAPS, or Support). */
export const isClinicalCenterUser = (activeUser) => {
    if (!activeUser || !activeUser.center) {
        return false;
    }
    const center = activeUser.center;
    return !center.rpm_flag
        && !center.gaps_flag
        && !center.ce_flag
        && !center.support_flag;
};

/** Non-billable profile on a clinical center. */
export const isClinicalNonBillableUser = (activeUser) =>
    isClinicalCenterUser(activeUser) && activeUser.billable === false;

/** In-chart RPM add-on enroll UX (banner, Enroll in RPM, enrolled state) — not queue actions. */
export const hasRpmEnrollInChartUx = (activeUser, roles) =>
    isRpmEnrollerClinicalCenter(activeUser, roles)
    || isClinicalNonBillableUser(activeUser);
